export interface AvailableAction {
  action: string;
  unavailableReasons?: string[];
}

export const isActionAvailable = <T extends string>(
  action: T,
  availableActions: AvailableAction[] | undefined,
): boolean => {
  if (!availableActions) {
    return false;
  }

  const actionItem = availableActions.find((item) => item.action === action);
  const actionExists = Boolean(actionItem);
  const actionIsUnavailable = Boolean(actionItem?.unavailableReasons?.length);

  return actionExists && !actionIsUnavailable;
};

export const getActionUnavailableReasons = <T extends string>(
  action: T,
  availableActions: AvailableAction[] | undefined,
): string[] | undefined => {
  if (!availableActions) {
    return undefined;
  }

  const actionItem = availableActions.find((item) => item.action === action);
  return actionItem?.unavailableReasons;
};
